<template>
  <div>
    <RouterLink
      v-if="enabled"
      :to="to"
    >
      <slot />
    </RouterLink>
    <slot v-else />
  </div>
</template>

<script>
export default {
  name: "ConditionalRouterLink",
  props: {
    enabled: {
      type: Boolean,
    },
    to: {
      type: [Object, String],
      required: true,
    },
  },
};
</script>
